<ng-container *transloco="let t; prefix: 'documents.scoring-metrics'">
  <div class="document-scoring-metrics__header">
    <xi-icon icon="analytics" iconSize="large"></xi-icon>

    {{ t('header') }}
  </div>

  @if (showOvertime()) {
    <app-document-scoring-metrics-overtime-section
      [sections]="sections()"
      [vectorMetrics]="vectorMetrics()"
      [settings]="settings()"
      [panel]="overtimePanel()"
      (selectSection)="onSectionSelected($event)"
      (settingsChanged)="onSettingsChanged($event)"
      (expandedChanged)="onExpandedChanged($event)"
    ></app-document-scoring-metrics-overtime-section>
  }

  @if (simpleScalarMetrics()?.length) {
    <app-document-scoring-metrics-metricdata-section
      [panel]="scalarMetricsPanel()"
      [metrics]="simpleScalarMetrics()"
      [allowSorting]="true"
      (expandedChanged)="onExpandedChanged($event)"
    ></app-document-scoring-metrics-metricdata-section>
  }

  @if (simpleMetadataMetrics()?.length) {
    <app-document-scoring-metrics-metricdata-section
      [panel]="metadataMetricsPanel()"
      [metrics]="simpleMetadataMetrics()"
      (expandedChanged)="onExpandedChanged($event)"
    ></app-document-scoring-metrics-metricdata-section>
  }
</ng-container>
